// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resources-banner {
    padding-top: 115px;
    overflow: hidden
    
}
.resources-banner .resource-library {
    margin-top: 30px;
}
.resource-library .card-title:before {
    content: "";
    border-left: 5px solid #ff5800;
    padding-left: 15px;   
}
.resources-banner .card-title {
    margin-bottom: 30px;
}
.resource-library .card-body p {
    font-size: 20px;
    margin-bottom: 30px;
}
.resource-library .nav.nav-tabs {
    background-color: #CCCCCC33;
    padding: 10px;
    display: flex;
    justify-content: flex-start;    
}
.resource-library .nav-tabs .nav-link.active, .resource-library .nav-tabs .nav-item.show .nav-link {
    background-color: #fff;
    border-color: #fff !important;
}
.resource-library .nav-tabs .nav-link {
    font-size: 20px;
    padding: 15px 45px;
}
.play-book .more-text {
    color: #ff5800;
    font-size: 20px;
}
.resource-form-content p {
    font-size: 20px;
}
.resource-form-content h3 {
    color: #ff5800;
}
.resource-form-content {
    background: #f5f5f5;
}
.contact-us-checkbox input[type="checkbox"] {
    width: 30px;
}
.contact-us-checkbox .MuiInput-underline:before {
    border: 1px solid transparent !important;
}
.contact-us-checkbox input[type="checkbox"]::after {
    border: none;
    transform: none;

}
.contact-us-checkbox .MuiInputLabel-formControl {
    transform:unset;
    left: 50px;
}
.contact-us-checkbox {
    position: relative;
}
.contact-us-checkbox .MuiInputLabel-root {
    top: 0 !important;
}
.MuiInputLabel-root {
    top: -25px !important;
    transform-origin: unset;
    font-weight: 300!important;
}
.resource-form-input h3 {
    color: #ff5800;
}
.MuiFormHelperText-root {
    color: red!important;
    font-weight: 500!important;
}
.checkbox-content {
    position: absolute;
    top: 0;
    left: 65px;
}

/* 
// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) { ... }

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) { ... }

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) { ... } */
@media (max-width: 575.98px) { 
    .resources-banner {
        padding-top: 70px;
    }
    /* .container-fluid {
        padding-right: 0!important;
        padding-left: 0!important;
    } */
    .resources-banner .resource-library {
        margin-top: 30px;
    }
    .resources-banner .card-title {
        margin-bottom: 15px;
        font-size: 22px;
    }
    .resource-library .card-body p {
        font-size: 16px;
        margin-bottom: 15px;
    }
    .resource-library .nav-tabs .nav-link {
        font-size: 20px;
        padding: 5px 45px;
    }
    .resource-library .nav.nav-tabs {
        justify-content: center;
    }
    .play-book h3 {
        font-size: 22px;
    }
    .play-book .more-text {
        font-size: 18px;
    }
    .resource-form-content p {
        font-size: 16px;
    }
 }`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/resources/resources.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB;;AAEJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,YAAY;IACZ,eAAe;;AAEnB;AACA;IACI,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;AACd;;AAEA;;;;;;;;uCAQuC;AACvC;IACI;QACI,iBAAiB;IACrB;IACA;;;OAGG;IACH;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;CACH","sourcesContent":[".resources-banner {\n    padding-top: 115px;\n    overflow: hidden\n    \n}\n.resources-banner .resource-library {\n    margin-top: 30px;\n}\n.resource-library .card-title:before {\n    content: \"\";\n    border-left: 5px solid #ff5800;\n    padding-left: 15px;   \n}\n.resources-banner .card-title {\n    margin-bottom: 30px;\n}\n.resource-library .card-body p {\n    font-size: 20px;\n    margin-bottom: 30px;\n}\n.resource-library .nav.nav-tabs {\n    background-color: #CCCCCC33;\n    padding: 10px;\n    display: flex;\n    justify-content: flex-start;    \n}\n.resource-library .nav-tabs .nav-link.active, .resource-library .nav-tabs .nav-item.show .nav-link {\n    background-color: #fff;\n    border-color: #fff !important;\n}\n.resource-library .nav-tabs .nav-link {\n    font-size: 20px;\n    padding: 15px 45px;\n}\n.play-book .more-text {\n    color: #ff5800;\n    font-size: 20px;\n}\n.resource-form-content p {\n    font-size: 20px;\n}\n.resource-form-content h3 {\n    color: #ff5800;\n}\n.resource-form-content {\n    background: #f5f5f5;\n}\n.contact-us-checkbox input[type=\"checkbox\"] {\n    width: 30px;\n}\n.contact-us-checkbox .MuiInput-underline:before {\n    border: 1px solid transparent !important;\n}\n.contact-us-checkbox input[type=\"checkbox\"]::after {\n    border: none;\n    transform: none;\n\n}\n.contact-us-checkbox .MuiInputLabel-formControl {\n    transform:unset;\n    left: 50px;\n}\n.contact-us-checkbox {\n    position: relative;\n}\n.contact-us-checkbox .MuiInputLabel-root {\n    top: 0 !important;\n}\n.MuiInputLabel-root {\n    top: -25px !important;\n    transform-origin: unset;\n    font-weight: 300!important;\n}\n.resource-form-input h3 {\n    color: #ff5800;\n}\n.MuiFormHelperText-root {\n    color: red!important;\n    font-weight: 500!important;\n}\n.checkbox-content {\n    position: absolute;\n    top: 0;\n    left: 65px;\n}\n\n/* \n// Small devices (landscape phones, less than 768px)\n@media (max-width: 767.98px) { ... }\n\n// Medium devices (tablets, less than 992px)\n@media (max-width: 991.98px) { ... }\n\n// Large devices (desktops, less than 1200px)\n@media (max-width: 1199.98px) { ... } */\n@media (max-width: 575.98px) { \n    .resources-banner {\n        padding-top: 70px;\n    }\n    /* .container-fluid {\n        padding-right: 0!important;\n        padding-left: 0!important;\n    } */\n    .resources-banner .resource-library {\n        margin-top: 30px;\n    }\n    .resources-banner .card-title {\n        margin-bottom: 15px;\n        font-size: 22px;\n    }\n    .resource-library .card-body p {\n        font-size: 16px;\n        margin-bottom: 15px;\n    }\n    .resource-library .nav-tabs .nav-link {\n        font-size: 20px;\n        padding: 5px 45px;\n    }\n    .resource-library .nav.nav-tabs {\n        justify-content: center;\n    }\n    .play-book h3 {\n        font-size: 22px;\n    }\n    .play-book .more-text {\n        font-size: 18px;\n    }\n    .resource-form-content p {\n        font-size: 16px;\n    }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
